import {createGlobalStyle, ThemeProps} from 'styled-components';
import {injectAdaptive} from './adaptive';
import {palette} from './palette';

export const animationDuration = {
  primary: 300,
  opacity: 200,

  swipe: 200,
};

export const curves = {
  easeOutQuint: `cubic-bezier(0.23, 1, 0.32, 1)`,
  easeOutBack: `cubic-bezier(0.175, 0.885, 0.32, 1.275)`,
};

export const breakpoints = {
  tablet: '540px',
};

export const sizeConstraints = {
  minWidth: '300px',
  maxContentWidth: '520px',
};

export const theme = {
  ...palette,
  ...sizeConstraints,

  buttonFill: '#2f2f2f',
  modalBackground: '#1f2021',

  keyBoardHeightValues: ['29%', '30%', '32%', '38%', '41%'],
  keyDarkBackground: '#c3c4c5',
  keyBackground: '#dbdcdd',
  keyBorder: 'rgba(0,0,0,.15)',

  font: `-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`,

  fontRegular: '1rem',
  fontSmaller: '0.75rem',

  activeControlStyle: `&:active { opacity: 0.3; }`,

  opacityAnimationStyle: `transition: opacity ${animationDuration.opacity}ms;`,
  defaultAnimationStyle: `transition:
    opacity ${animationDuration.opacity}ms,
    transform ${animationDuration.primary}ms ${curves.easeOutQuint};`,

  fitContainerStyle: `
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  `,
};

export const GlobalStyle = createGlobalStyle`
  html,
  body,
  #app {
    width: 100%;
    height: 100%;
    min-height: 100vh;
    min-width: ${theme.minWidth};
    touch-action: manipulation;
    font-family: ${theme.font};
    ${injectAdaptive('font-size', ['15px', '16px', '17px', '18px', '19px'])};
    line-height: 18px;
    -webkit-font-smoothing: antialiased;
    background: ${theme.dark};
    color: ${theme.light};
    user-select: none;
  }

  html,
  body {
    overflow: hidden;
  }

  #app {
    position: fixed;
    z-index: 1;
  }

  *,
  *::after,
  *::before {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  a {
    text-decoration: none;
    color: ${theme.yellow};

    &:active {
      opacity: 0.3;
    }
  }
`;

export type Theme = typeof theme;
export type StyledInterface = ThemeProps<Theme>;
